/* =========================================================
   KIMOY CUSTOM.JS - V118 COMPANION STABLE
   目标：
   1) 修复 cart drawer 首次打开 / 返回页后再打开时的底部模块刷新
   2) 不再强行显示 Kimoy 优惠条，避免 Calculating 卡住
   3) 主动调用 KimoyDrawerV118/V116 等 refresh，修复 COPY 按钮未绑定
   4) 保留 shipping protection / footer 稳定刷新
========================================================= */
(function () {
  'use strict';

  if (window.__kimoyCustomJsV118Loaded) return;
  window.__kimoyCustomJsV118Loaded = true;

  var UI_RETRY_DELAYS = [0, 120, 260, 520, 900, 1400];
  var OFFER_RETRY_INTERVAL = 650;
  var OFFER_RETRY_MAX = 10;
  var CART_API_RE = /\/cart(\/(add|change|update|clear))?(\.js)?(\?|$)/i;

  var lastScheduleAt = 0;
  var mutationDebounceTimer = null;
  var offerRetryTimer = null;
  var bootstrapTimer = null;

  function safe(fn) {
    try {
      return fn();
    } catch (e) {
      return null;
    }
  }

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function matches(el, selector) {
    return !!(el && el.matches && el.matches(selector));
  }

  function isCartUrl(url) {
    return CART_API_RE.test(String(url || ''));
  }

  function getDrawer() {
    return (
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('.cart-drawer') ||
      document.querySelector('.drawer--cart') ||
      document.querySelector('.wt-cart__drawer') ||
      document.querySelector('[data-cart-drawer]')
    );
  }

  function getOfferBox() {
    var drawer = getDrawer();
    if (!drawer) return null;

    return (
      drawer.querySelector('#drawer-smart-discount') ||
      drawer.querySelector('.cd-box-slim') ||
      drawer.querySelector('[data-cart-offer-box]') ||
      drawer.querySelector('.cart-offer-box') ||
      drawer.querySelector('.cart-offer') ||
      drawer.querySelector('.cart-discount-box')
    );
  }

  function isKimoyOfferBox(el) {
    return !!(el && el.matches && el.matches('#drawer-smart-discount, .cd-box-slim'));
  }

  function getCartRelatedTargets(root) {
    if (!root) return [];

    var selectors = [
      /* 故意不包含 Kimoy 优惠条，避免提前显示半成品 */
      '[data-cart-offer-box]',
      '.cart-offer-box',
      '.cart-offer',
      '.cart-discount-box',
      '.cart-discount-progress',
      '.discount-progress',
      '.progress-bar-wrapper',
      '.progress-bar-container',

      /* protection / upsell */
      '[data-shipping-protection-wrap]',
      '.shipping-protection-wrap',
      '.shipping-protection',
      '.cart-shipping-protection',
      '.cart-drawer__upsell',
      '.cart-drawer__upsells',
      '.upsell-cart-wrapper',
      '.shipping-protection-widget',
      '#xcotton_wrapper',

      /* footer / ctas */
      '.cart-drawer__footer',
      '.drawer__footer',
      '.cart-footer',
      '.cart-drawer-footer',
      '.cart__footer',
      '.ajaxcart__footer',
      '.cart__ctas',
      '.drawer__checkout',
      '.cart-drawer__checkout',

      /* checkout buttons */
      'button[name="checkout"]',
      'a[href="/checkout"]'
    ];

    return Array.prototype.slice.call(root.querySelectorAll(selectors.join(',')));
  }

  function forceVisible(el) {
    if (!el) return;
    if (isKimoyOfferBox(el)) return;

    if (el.hidden) el.hidden = false;
    if (el.hasAttribute && el.hasAttribute('hidden')) {
      el.removeAttribute('hidden');
    }

    if (el.style) {
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('opacity');
      el.style.removeProperty('max-height');
      el.style.removeProperty('height');
    }
  }

  function normalizeDrawerUI() {
    var drawer = getDrawer();
    if (!drawer) return;

    forceVisible(drawer);
    getCartRelatedTargets(drawer).forEach(forceVisible);

    var hiddenClassTargets = drawer.querySelectorAll(
      '.hidden, .is-hidden, .visually-hidden'
    );

    hiddenClassTargets.forEach(function (el) {
      if (isKimoyOfferBox(el)) return;

      if (
        matches(
          el,
          '.cart-drawer__footer, .drawer__footer, .cart-footer, .cart-offer-box, .cart-offer, .shipping-protection-wrap, .shipping-protection, .cart-drawer__upsell, .cart-drawer__upsells, #xcotton_wrapper'
        )
      ) {
        el.classList.remove('hidden', 'is-hidden', 'visually-hidden');
        forceVisible(el);
      }
    });
  }

  function dispatchCartEvents() {
    var eventNames = [
      'cart:refresh',
      'cart:updated',
      'cart:drawer:updated',
      'cart-drawer:updated',
      'theme:cart:updated',
      'ajaxProduct:added',
      'quick-cart:updated'
    ];

    eventNames.forEach(function (name) {
      safe(function () {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });
    });

    safe(function () {
      window.dispatchEvent(new Event('resize'));
    });
  }

  function callKnownThemeFunctions() {
    var fnNames = [
      'updateCartOfferBox',
      'renderCartOfferBox',
      'refreshCartOfferBox',
      'updateCartProgress',
      'renderCartProgress',
      'refreshCartProgress',
      'updateDrawerSmartDiscount',
      'renderDrawerSmartDiscount',
      'refreshDrawerSmartDiscount',
      'updateSmartDiscount',
      'renderSmartDiscount',
      'refreshSmartDiscount',

      'initShippingProtection',
      'renderShippingProtection',
      'refreshShippingProtection',

      'renderCartDrawer',
      'refreshCartDrawer',
      'updateCartDrawer',
      'initCartDrawer'
    ];

    fnNames.forEach(function (name) {
      safe(function () {
        if (typeof window[name] === 'function') {
          window[name]();
        }
      });
    });
  }

  function callKimoyDrawerRefresh() {
    var names = [
      'KimoyDrawerV118',
      'KimoyDrawerV117',
      'KimoyDrawerV1161',
      'KimoyDrawerV116',
      'KimoyDrawerV115',
      'KimoyDrawerV114'
    ];

    names.forEach(function (name) {
      safe(function () {
        if (window[name] && typeof window[name].refresh === 'function') {
          window[name].refresh();
        }
      });
    });
  }

  function offerLooksStuck() {
    var box = getOfferBox();
    if (!box) return false;

    var style = window.getComputedStyle ? getComputedStyle(box) : null;
    if (style && style.display === 'none') return false;

    var txt = (box.innerText || '').replace(/\s+/g, ' ').trim();

    return (
      /Calculating your best available offer/i.test(txt) ||
      /Saved:\s*-\s*\$0\.00/i.test(txt) ||
      /Saved:\s*\$0\.00/i.test(txt)
    );
  }

  function startOfferRetry(reason) {
    var count = 0;

    if (offerRetryTimer) {
      clearInterval(offerRetryTimer);
      offerRetryTimer = null;
    }

    offerRetryTimer = setInterval(function () {
      count += 1;

      if (!offerLooksStuck()) {
        clearInterval(offerRetryTimer);
        offerRetryTimer = null;
        return;
      }

      safe(function () {
        callKnownThemeFunctions();
        callKimoyDrawerRefresh();
        dispatchCartEvents();
      });

      if (count >= OFFER_RETRY_MAX) {
        clearInterval(offerRetryTimer);
        offerRetryTimer = null;
      }
    }, OFFER_RETRY_INTERVAL);
  }

  function refreshCartDrawerUI(reason) {
    safe(function () {
      normalizeDrawerUI();
      callKnownThemeFunctions();
      callKimoyDrawerRefresh();
      dispatchCartEvents();

      setTimeout(function () {
        callKimoyDrawerRefresh();
      }, 80);

      setTimeout(function () {
        callKimoyDrawerRefresh();
      }, 260);

      if (offerLooksStuck()) {
        startOfferRetry(reason || 'ui-refresh');
      }
    });
  }

  function scheduleRefresh(reason) {
    var t = now();

    if (t - lastScheduleAt < 90) return;
    lastScheduleAt = t;

    UI_RETRY_DELAYS.forEach(function (delay) {
      setTimeout(function () {
        refreshCartDrawerUI(reason || 'unknown');
      }, delay);
    });
  }

  /* 首屏 */
  document.addEventListener('DOMContentLoaded', function () {
    scheduleRefresh('dom-ready');
  });

  window.addEventListener('load', function () {
    scheduleRefresh('window-load');
  });

  window.addEventListener('pageshow', function () {
    scheduleRefresh('pageshow');
  });

  /* 加购 form */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches) return;

      if (form.matches('form[action*="/cart/add"]')) {
        scheduleRefresh('submit-add-to-cart');
      }
    },
    true
  );

  /* 点击触发 */
  document.addEventListener(
    'click',
    function (e) {
      var trigger = closest(
        e.target,
        [
          'button[name="add"]',
          'button[type="submit"][name="add"]',
          '.product-form__submit',
          '[data-add-to-cart]',
          '[name="add"]',
          '.header__icon--cart',
          '[data-cart-drawer]',
          '.cart-drawer-trigger',
          '.wt-cart__icon',
          'a[href="/cart"]',
          '.cart-drawer .quantity__button',
          '#CartDrawer .quantity__button',
          '.wt-cart__drawer .quantity__button'
        ].join(',')
      );

      if (trigger) {
        scheduleRefresh('click-trigger');
      }
    },
    true
  );

  /* drawer 内 change */
  document.addEventListener(
    'change',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (target.closest('cart-drawer, #CartDrawer, .cart-drawer, .wt-cart__drawer, .drawer--cart')) {
        scheduleRefresh('drawer-change');
      }
    },
    true
  );

  /* Shopify sections */
  document.addEventListener('shopify:section:load', function () {
    scheduleRefresh('shopify-section-load');
  });

  document.addEventListener('shopify:section:reorder', function () {
    scheduleRefresh('shopify-section-reorder');
  });

  /* Hook fetch */
  if (window.fetch) {
    var nativeFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var req = args[0];
      var url = '';

      if (typeof req === 'string') {
        url = req;
      } else if (req && req.url) {
        url = req.url;
      }

      return nativeFetch.apply(this, args).then(function (response) {
        if (isCartUrl(url)) {
          scheduleRefresh('fetch-cart-api');
        }
        return response;
      });
    };
  }

  /* Hook XHR */
  if (window.XMLHttpRequest) {
    var NativeXHR = window.XMLHttpRequest;
    var originalOpen = NativeXHR.prototype.open;
    var originalSend = NativeXHR.prototype.send;

    NativeXHR.prototype.open = function (method, url) {
      this.__kimoyCartUrl = url || '';
      return originalOpen.apply(this, arguments);
    };

    NativeXHR.prototype.send = function () {
      this.addEventListener('loadend', function () {
        if (isCartUrl(this.__kimoyCartUrl)) {
          scheduleRefresh('xhr-cart-api');
        }
      });
      return originalSend.apply(this, arguments);
    };
  }

  function mutationLooksCartRelated(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];

      if (m.type === 'childList') {
        var nodes = [];
        if (m.addedNodes && m.addedNodes.length) {
          nodes = Array.prototype.slice.call(m.addedNodes);
        }

        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!node || node.nodeType !== 1) continue;

          var cls = node.className ? String(node.className) : '';
          var id = node.id ? String(node.id) : '';

          if (
            /cart|drawer|shipping|discount|offer|upsell|xcotton/i.test(cls) ||
            /cart|drawer/i.test(id) ||
            (node.matches &&
              node.matches('cart-drawer, #CartDrawer, .cart-drawer, .drawer--cart, .wt-cart__drawer'))
          ) {
            return true;
          }

          if (
            node.querySelector &&
            node.querySelector(
              'cart-drawer, #CartDrawer, .cart-drawer, .drawer--cart, .wt-cart__drawer, .cart-drawer__footer, .drawer__footer, .shipping-protection, .cart-offer-box, #xcotton_wrapper'
            )
          ) {
            return true;
          }
        }
      }

      if (m.type === 'attributes' && m.target) {
        var target = m.target;
        if (
          target.matches &&
          target.matches(
            'cart-drawer, #CartDrawer, .cart-drawer, .drawer--cart, .wt-cart__drawer, .cart-drawer__footer, .drawer__footer, .shipping-protection, .cart-offer-box, #xcotton_wrapper'
          )
        ) {
          return true;
        }
      }
    }

    return false;
  }

  var observer = new MutationObserver(function (mutations) {
    if (!mutationLooksCartRelated(mutations)) return;

    clearTimeout(mutationDebounceTimer);
    mutationDebounceTimer = setTimeout(function () {
      scheduleRefresh('mutation-observer');
    }, 120);
  });

  safe(function () {
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'open']
    });
  });

  /* 首屏兜底 */
  (function bootstrapRetry() {
    var count = 0;
    var max = 6;

    if (bootstrapTimer) {
      clearInterval(bootstrapTimer);
      bootstrapTimer = null;
    }

    bootstrapTimer = setInterval(function () {
      count += 1;
      scheduleRefresh('bootstrap-retry-' + count);

      if (count >= max) {
        clearInterval(bootstrapTimer);
        bootstrapTimer = null;
      }
    }, 700);
  })();
})();